
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"9","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.75 12V2.625l-1.063-.852-1.078.868V12H2.5V3.516L1.133 4.68l-.43-.508L4.438.43h.5l3.734 3.742-.43.508L6.86 3.508V12H5.75z","fill":"currentColor"}})])
          )
        }
      }
    